import { createSlice } from "@reduxjs/toolkit";
import { InitialPlatformInfo } from "../domain/models/PlatformInfo";
import { AppState } from "../store";
import { PlatformInfoServiceImpl } from "../services/PlatformInfoServiceImpl";

export const platformInfoSlice = createSlice({
    name: "platformInfo",
    initialState: InitialPlatformInfo,
    reducers: {},
    extraReducers: (builder) => {
        // handle get /platform-info
        builder.addCase(
            PlatformInfoServiceImpl.getPlatformInfoThunk.fulfilled,
            (state, action) => {
                state.dto = action.payload;
            }
        );
    },
});

export const selectPlatformInfo = (state: AppState) => state.platformInfo.dto;

// export const {} = platformInfoSlice.actions;

export default platformInfoSlice.reducer;
